import { render } from "./RoversIcon.vue?vue&type=template&id=4de04e97"
import script from "./RoversIcon.vue?vue&type=script&lang=js"
export * from "./RoversIcon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__